import { Checkmark24Regular, Dismiss24Regular } from '@/components/Icon'
import { IconButton } from '@mui/material'
import Tooltip from '@/components/Tooltip'
import styles from './index.module.scss'

export default function AiAskBarRightActionsDictating({
  dictationCancelRef,
  handleDictationConfirm,
  handleDictationCancel,
}) {
  return (
    <>
      <Tooltip text="done" placement="bottom">
        <IconButton
          type="button"
          className={styles.dictationActionBtn}
          onClick={handleDictationConfirm}
          aria-label="Done dictating"
        >
          <Checkmark24Regular className={styles.dictationIcon} aria-hidden />
        </IconButton>
      </Tooltip>
      <Tooltip text="cancel" placement="bottom">
        <IconButton
          ref={dictationCancelRef}
          type="button"
          className={styles.dictationActionBtn}
          onClick={handleDictationCancel}
          aria-label="Cancel dictation"
        >
          <Dismiss24Regular className={styles.dictationIcon} aria-hidden />
        </IconButton>
      </Tooltip>
    </>
  )
}
